module.exports = __webpack_public_path__ + "img/download-black.1bb483ea.svg";